import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Seu CSS
import 'react-toastify/dist/ReactToastify.css'; // CSS do Toastify
import App from './App';
import { iniciarAvisoDeAtualizacao } from './atualizacao';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// avisa/recarrega quando sai um build novo (sem precisar pedir F5 aos usuários)
iniciarAvisoDeAtualizacao();
